module.exports = __webpack_public_path__ + "img/item9.d9fadf2c.png";